
import { Component, computed, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { FormDirective } from '../../shared/directives/form.directive';
import { Option, match, none, some } from '../../shared/functions/functional';
import { EquipmentDataCablesComponent } from './equipment-data-cables/equipment-data-cables.component';
import { EquipmentDataPvComponent } from './equipment-data-pv/equipment-data-pv.component';

@Component({
    selector: 'app-equipment-data',
    imports: [MatCardModule, ReactiveFormsModule, FormDirective, FormsModule, MatSelectModule, EquipmentDataCablesComponent, EquipmentDataPvComponent],
    templateUrl: './equipment-data.component.html'
})
export class EquipmentDataComponent {

  private equipment = signal<Option<'Cables' | 'PV'>>(none);

  protected readonly formValid = signal<boolean>(false);
  protected readonly formDirty = signal<boolean>(false);

  protected readonly viewModel = computed(() => {
    return {

      formValid: this.formValid(),
      formDirty: this.formDirty(),

      equipments: [{ value: 'Cables', label: 'Cables' }, { value: 'PV', label: 'PV' }],

      showCables: match(() => false, x => x === 'Cables')(this.equipment()),
      showPV: match(() => false, x => x === 'PV')(this.equipment()),

    };
  });

  protected get vm() { return this.viewModel(); }


  onEquipmentChange($event: MatSelectChange): void {
    const equipment = $event.value;
    if (equipment === 'Cables' || equipment === 'PV') {
      this.equipment.set(some(equipment));
    }
  };

}

